import React from 'react'
import Hidden from 'material-ui/Hidden'
import {Tab as MUITab} from 'material-ui/Tabs'
import AccountBoxIcon from 'material-ui-icons/AccountBox'
import PaymentIcon from 'material-ui-icons/Payment'
import {Tabs} from '../../../components'

import Container from '../../../common/components/Container'
import ErrorMessage from '../../../common/components/ErrorMessage'
import HeaderProgress from '../../../common/components/HeaderProgress'
import ProfileBasic from '../containers/profileBasic'
import Addresses from '../containers/addresses'
import PaymentMethod from '../containers/paymentMethod'

class Profile extends React.Component {

  state = {
    tab: 0,
  }

  handleChange = (e, v) => {
    this.setState({tab: v})
  }

  render() {
    const {error, isFetching} = this.props
    if (error !== '') return <ErrorMessage error={error}/>
    if (isFetching === true) return <HeaderProgress show={true}/>
    return (
      <Container style={{maxWidth: 900}}>
        <Hidden only={['sm', 'md', 'lg', 'xl']}>
          <Tabs value={this.state.tab} onChange={this.handleChange}>
            <MUITab icon={<AccountBoxIcon/>}/>
            <MUITab icon={<PaymentIcon/>}/>
          </Tabs>
        </Hidden>
        <Hidden only={['xs']}>
          <Tabs value={this.state.tab} onChange={this.handleChange} scrollButtons="auto">
            <MUITab label={'Mi cuenta'}/>
            <MUITab label={'Método de pago'}/>
          </Tabs>
        </Hidden>
        {this.state.tab === 0 ? <AccountTab/> : null}
        {this.state.tab === 1 ? <PaymentMethodTab/> : null}
        {/*{this.state.tab === 2 ? <BillingHistoryTab/> : null}*/}
      </Container>
    )
  }
}

const AccountTab = () => (
  <div>
    <ProfileBasic/>
    <Addresses/>
    {/*<ChangeEmail/>*/}
    {/*<ChangePhone/>*/}
  </div>
)

const PaymentMethodTab = () => (
  <div>
    <PaymentMethod/>
  </div>
)

Profile.propTypes = {}

export default Profile



// WEBPACK FOOTER //
// ./src/sections/profile/components/Profile.js